<template>
  <v-app dark>
    <v-main>
      <div v-if="errorMessage">
        {{errorMessage}}
      </div>

      <div v-if="pod" class="" data-cy="">
        <div v-if="isVideoPod" justify="center" >
            <PlyrPlayer v-if="hasRequiredFile" v-bind:pod="pod" view-context="embedded" allow-quality-selection />
            <div v-else>
              <NoPreviewAvailable assetType="video" />
            </div>
        </div>

        <div v-if="isAudioPod" justify="center" >
          <AudioPlayer v-if="hasRequiredFile" v-bind:pod="pod" />

          <div v-else>
            <NoPreviewAvailable assetType="audio" />
          </div>
        </div>

        <div v-if="isImagePod" justify="center" >
          <PodImageView v-if="hasRequiredFile" v-bind:pod="pod" />
          <div v-else>
            <NoPreviewAvailable assetType="image" />
          </div>
        </div>

      </div>
    </v-main>
  </v-app>
</template>

<script>
import { useEmbedMediaStore } from '@/stores/EmbedMediaStore.js'
import MimetypeHelper from '../../components/MimetypeHelper.js'

import PlyrPlayer from '../pods2/components/players/PlyrPlayer.vue'
import AudioPlayer from '../pods2/components/players/AudioPlayer.vue'
import PodImageView from '../pods2/components/PodImageView.vue'
import NoPreviewAvailable from '../pods2/components/NoPreviewAvailable.vue'

export default {
  name: "EmbeddedIndex",
  components: {
    PlyrPlayer,
    AudioPlayer,
    PodImageView,
    NoPreviewAvailable,
  },
  data: function() {
    return {
      code: "",
      errorMessage: ""
    };
  },
  mounted: function() {
    this.code = this.$route.params.code;
    let self = this;

    document.getElementsByTagName("html")[0].style.overflowY = "hidden";


    console.log("Embedded mounted");
    console.log("Code", this.code);

    const embedMediaStore = useEmbedMediaStore();
    embedMediaStore.refreshEmbedlinkInfo(this.code)
    .catch(function(error) {
      if (error &&
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.error.message
      ) {
        self.errorMessage = error.response.data.error.message
      } else {
        self.errorMessage = "Error!";
        console.log(error);
      }
    })
  },
  computed: {
    embedlinkInfo: function() {
      const embedMediaStore = useEmbedMediaStore();
      return embedMediaStore.getEmbedlinkInfo;
    },
    pod: function() {
      if (this.embedlinkInfo && this.embedlinkInfo.pod) {
        return this.embedlinkInfo.pod;
      }

      return false;
    },

    isVideoPod: function() {
      return MimetypeHelper.isMimetypeVideo(this.pod);
    },
    isAudioPod: function() {
      return MimetypeHelper.isMimetypeAudio(this.pod);
    },
    isImagePod: function() {
      return MimetypeHelper.isMimetypeImage(this.pod);
    },

    hasRequiredFile: function() {
      if (!this.embedlinkInfo) {
        return false;
      }

      if (this.embedlink && this.embedlink.params) {
        let params = JSON.parse(this.embedlink.params);
        if (params && params.asset && params.asset == 'origin') {
          return this.hasRawFile;
        }
      }

      if (this.isImagePod) {
        return this.hasThumbnailFile;
      }

      return this.hasTranscodedFile;
    },
    hasRawFile: function() {
      if (this.pod &&
          this.pod.asset &&
          this.pod.asset.raw &&
          this.pod.asset.raw.length > 0
      ) {
        return true;
      }

      return false;
    },
    hasTranscodedFile: function() {
      if (this.pod &&
          this.pod.asset &&
          this.pod.asset.web &&
          this.pod.asset.web.length > 0
      ) {
        return true;
      }

      return false;
    },
    hasThumbnailFile: function() {
      if (this.pod &&
          this.pod.asset &&
          this.pod.asset.thumbnail &&
          this.pod.asset.thumbnail.length > 0
      ) {
        return true;
      }

      return false;
    },
  }
}
</script>

<style>
</style>
